import React, { createContext, useContext, useEffect, useState } from "react";
import { University, UniversityContextType } from "../types/University";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";

const UniversityContext = createContext<UniversityContextType | undefined>(
  undefined
);

export const UniversityProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [universities, setUniversities] = useState<University[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchUniversities = async () => {
      try {
        setLoading(true);
        const querySnap = await getDocs(collection(db, "university-listing"));
        const data = querySnap.docs.map((doc) => doc.data() as University);
        setUniversities(data);
      } catch (err) {
        console.error(err);
        setError("Failed to load universities");
      } finally {
        setLoading(false);
      }
    };
    fetchUniversities();
  }, []);

  return (
    <UniversityContext.Provider value={{ universities, loading, error }}>
      {children}
    </UniversityContext.Provider>
  );
};

export const useUniversities = () => {
  const context = useContext(UniversityContext);
  if (!context)
    throw new Error("useUniversities must be used inside UniversityProvider");
  return context;
};
